import React from "react";

import "../scss/Elements/_tables.scss"
import "../scss/Pages/_fvisits.scss"


import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { VisitsControl } from "../components/Tables/VisitsControlTable";

function FollowVisits() {
  const {
    titleVisitsString
  } = useTranslationHook();

  return (
      <div className="table-module-container">
        <Helmet>
          <title>{titleVisitsString}</title>
        </Helmet>
          <div className="datatable start-visits-control-tour">
            <VisitsControl />
          </div>
      </div>
    );
  }

export default FollowVisits;